export default "__VITE_ASSET__2eBcYnLo__"